import React from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import OverflowTitleTooltip from "../common/display/OverflowTitleTooltip";
import Icon from "@mui/material/Icon";
import { ListItemIcon, ListItemText, StyledNavLink } from "./MenuStyle";

const InternalMenuItem = ({ menu, drawerOpen, activeRoute }) => {
  const { t } = useTranslation();

  return (
    <StyledNavLink to={menu.path} isActive={activeRoute && activeRoute(menu.route)}>
      <ListItemIcon drawerOpen={drawerOpen}>
        <Icon>{menu.icon}</Icon>
      </ListItemIcon>
      <OverflowTitleTooltip title={t(menu.text)}>
        <ListItemText primary={t(menu.text)} disableTypography={true} drawerOpen={drawerOpen} />
      </OverflowTitleTooltip>
    </StyledNavLink>
  );
};

InternalMenuItem.propTypes = {
  menu: PropTypes.object,
  drawerOpen: PropTypes.bool.isRequired,
  activeRoute: PropTypes.func.isRequired
};

export default InternalMenuItem;
